import BasePage from "./subBasePage";

export default class Page3Sub4 extends BasePage{
    constructor(info){
        super(info);
        // super.set();

        this.ele = info.ele;
        this.pageTl = new TimelineMax({ paused: true, ease: Power2.easeOut });
        this._pageSet();
        this._bindEvent();
    }

    _pageSet(){
        this.hideMotion
            .fromTo( this.ele, 0.7, { autoAlpha: 1 }, { autoAlpha: 0 })
            .call(()=>{ this._hideComplete() }, null, null, '-=0.5');

        this.showMotion
            .fromTo( this.ele, 0.7, { x: this._num, autoAlpha: 0, rotationY: this._y }, { x: "0%", autoAlpha: 1, rotationY: 0, ease: Power2.easeOut })

        this.pageTl
            .call(()=>{ $( this.ele ).find('li').eq(3).addClass('on') }, null, null, '-=0.1')

            .fromTo( this.ele.querySelector('.tit strong em'), 1, { y: 90, autoAlpha: 0 }, { y: 0, autoAlpha: 1, delay: 0.1, ease: Back.easeOut.config(1.05) })
            .fromTo( this.ele.querySelector('.tit span em'), 1, { y: 90, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Back.easeOut.config(1.05) }, "-=0.7")

            .addLabel('mo1', '-=0.5')
            .fromTo( this.ele.querySelector('.txt-1'), 0.5, { y: 50, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, 'mo1')

            .fromTo( this.ele.querySelector('.char'), 1, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power0.easeNone }, "mo1")


    }

    _pageMotion(){
        this.pageTl.restart();
    }

    _hide(){
        setTimeout(()=>{
            this.pageTl.reverse();
        }, 500)
    }

    _bindEvent(){
        this.ele.addEventListener('onComplete', this._pageMotion.bind(this) );
        this.ele.addEventListener('hideComplete', this._hide.bind(this) );
    }

    show( di ){
        if( di == 'next' || di == 'prev' ){
            this._num = "100%";
            this._y = 10;
        }

        this.showMotion = new TimelineMax({paused: true, onComplete:()=>{this._showComplete()}});
        this.showMotion
            .fromTo( this.ele, 0.7, { x: this._num, autoAlpha: 0, rotationY: this._y }, { x: "0%", autoAlpha: 1, rotationY: 0, ease: Power2.easeOut })
        super.show();
    }
}


// WEBPACK FOOTER //
// ./src/js/subDeath/page3_sub4.js